<template>
    <b-row class="design-body m-0">
        <b-col class="design-page-canvas">
            <b-row class="design-page-canvas-header">
                <div style="width: 100%; padding-right: 10px;">
                    <router-link to="/dstore/design" class="design-home float-left">
                        <img src="@/assets/images/actions/back-button-design.svg"  alt="Phone Icon">
                    </router-link>
                    <div class="design-title float-left">
                        <span><input type="text" v-model="form.designName" /> </span>
                    </div>
                    <div class="float-right mt-2">
                        <b-button variant="primary" v-bind:disabled="loading" @click="preValidateForm('publish')" class="float-right new-badge">
                            <template v-if="loading && publishDesignProgress">
                                Publishing...
                            </template>
                            <template v-else>
                                Publish
                            </template>
                        </b-button>
                        <b-button variant="primary" v-bind:disabled="loading" @click="preValidateForm('save')" class="float-right new-badge invert-new-badge">
                            <template v-if="loading">
                                Saving Draft...
                            </template>
                            <template v-else>
                                Save Draft
                            </template>
                        </b-button>
                    </div>
                </div>
            </b-row>
            <b-row class="design-page-canvas-main">
                <b-col class="canvas-background">
                    <b-row class="mt-4 mr-4">
                        <b-col class="text-right">
                            <span class="mr-3" style="position: relative; right: -4px; top: -11px;">Guides </span> <switches v-model="guides" theme="custom" color="primary"></switches>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="text-center">
                            <center>
                                <div id="mobile-canvas">
                                    <div class="background-display">
                                        <b-row v-if="form.showLogo">
                                            <b-col><div class="image-upload-preview" style="overflow: hidden;">
                                                <p class="form-list" v-show="guides" style="position: absolute; margin-left: 4px; margin-top: 4px;">A</p>
                                                <div v-if="form.logo_image"><b-img :src="form.logo_image" fluid /></div>
                                            </div></b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col><div class="poster-preview" style="overflow: hidden;">
                                                <p class="form-list" v-show="guides" style="position: absolute; margin-left: 4px; margin-top: 4px;">B</p>
                                                <template v-if="selected_image_for_rotation === null">
                                                    <img v-if="banner_images[0].image !== ''" :src="banner_images[0].image" alt="Product Image">
                                                </template>
                                                <template v-else>
                                                    <img v-if="banner_images[selected_image_for_rotation].image !== ''" :src="banner_images[selected_image_for_rotation].image" alt="Product Image">
                                                </template>
                                            </div></b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>
                                                <p id="information">Information</p>
                                                <p id="more-info">More info</p>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </div>
                            </center>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-col>
        <b-col class="design-page-form" cols="4">
            <b-row>
                <b-col cols="10">
                    <div role="group" class="sl-helper b-form-group form-group">
                        <label for="programname" class="col-form-label pt-0 float-left">Program Name</label>
                        <i class="guide-tooltip float-left" id="programname-tooltip"></i>
                        <b-popover target="programname-tooltip"
                                   triggers="hover"
                                   content="This is the official name of your loyalty program.">
                        </b-popover>
                        <div>
                            <input id="programname" type="text" required="required" aria-required="true" class="form-control" v-model="form.designName">
                        </div>
                        <b-form-group
                            class="secondary-label"
                            style="font-size: 14px;"
                            :invalid-feedback="errorMessage('name')"
                            :state="isValid('name')">
                        </b-form-group>
                    </div>
                </b-col>
            </b-row>
            <b-row class="d-none">
                <b-col cols="10">
                    <div role="group" class="sl-helper b-form-group form-group">
                        <label for="pointsname" class="col-form-label pt-0 float-left">Points Name</label>
                        <i class="guide-tooltip float-left" id="points-tooltip"></i>
                        <b-popover target="points-tooltip"
                                   triggers="hover"
                                   content="This is the name of your loyalty program's point currency.">
                        </b-popover>
                        <div>
                            <input id="pointsname" type="text" required="required" aria-required="true" class="form-control">
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="10">
                    <div role="group" class="sl-helper b-form-group form-group mb-2">
                        <div style="height: 25px">
                            <p class="form-list float-left">A</p>
                            <label class="col-form-label pt-0 float-left" style="">LOGO</label> <switches v-model.number="form.showLogo" theme="custom" color="primary"></switches>
                            <i class="guide-tooltip float-left mr-2 ml-2" id="logo-tooltip"></i>
                            <b-popover target="logo-tooltip"
                                       triggers="hover"
                                       content="This is your company brand's logo that will appear when the customer application is launched.">
                            </b-popover>
                        </div>
                        <span v-if="form.logo_image" class="previewremovelogo" v-b-modal="'delete-modal-logo'"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" class="icon icon-remove" style="top: -7.5px; right: -5px;"><path d="M511.921231 0C229.179077 0 0 229.257846 0 512 0 794.702769 229.179077 1024 511.921231 1024 794.781538 1024 1024 794.702769 1024 512 1024 229.257846 794.781538 0 511.921231 0ZM732.041846 650.633846 650.515692 732.081231C650.515692 732.081231 521.491692 593.683692 511.881846 593.683692 502.429538 593.683692 373.366154 732.081231 373.366154 732.081231L291.761231 650.633846C291.761231 650.633846 430.316308 523.500308 430.316308 512.196923 430.316308 500.696615 291.761231 373.523692 291.761231 373.523692L373.366154 291.918769C373.366154 291.918769 503.453538 430.395077 511.881846 430.395077 520.349538 430.395077 650.515692 291.918769 650.515692 291.918769L732.041846 373.523692C732.041846 373.523692 593.447385 502.547692 593.447385 512.196923 593.447385 521.412923 732.041846 650.633846 732.041846 650.633846Z" fill="#ff8828"></path></svg></span>
                        <b-modal id="delete-modal-logo" title="Delete Logo Image">
                            <p class="modal-main-message">Are you sure you want delete this logo?</p>
                            <div slot="modal-footer">
                                <b-btn variant="ghost" class="mr-1 btn-cancel" @click="hideModal('delete-modal-logo')">
                                    Cancel
                                </b-btn>
                                <b-btn variant="primary" class="ml-1" @click="removeImage('logo')">
                                    Yes, Delete
                                </b-btn>
                            </div>
                        </b-modal>
                        <div id="logo-container" class="border mb-2">
                            <img v-if="form.logo_image" :src="form.logo_image" alt="Logo Image">
                            <div class="upload-icon rounded-circle border mb-1" v-b-modal.uploadLogo></div>
                        </div>
                        <b-form-group
                            class="secondary-label"
                            style="font-size: 14px;"
                            :invalid-feedback="errorMessage('logo_image')"
                            :state="isValid('logo_image')">
                        </b-form-group>
                        <span class="image-size">Recommended size : 150 x 70px</span>
                        <b-modal id="uploadLogo" title="Upload Logo">
                            <div id="image-logo-container" class="border mx-auto">
                                <croppa
                                    v-model="myLogoCroppa"
                                    @new-image-drawn="onNewLogoImage"
                                    @zoom="onLogoZoom"
                                    :width="200"
                                    :height="200"
                                    placeholder="Choose a Logo"
                                    :show-remove-button="true"
                                    :placeholder-font-size="14"
                                    remove-button-color="#ff8828">
                                </croppa>
                            </div>
                            <div id="logo-image-range-container" class="mx-auto mt-2">
                                <input type="range" class="custom-range" id="customRangelogo" @input="onLogoSliderChange" :min="sliderLogoMin" :max="sliderLogoMax" step=".001" v-model="sliderLogoVal">
                            </div>
                            <div slot="modal-footer">
                                <b-button variant="secondary" @click="cancelUploadLogo" style="margin-right: .25rem;">
                                    Cancel
                                </b-button>
                                <b-button variant="primary" @click="saveUploadLogo" style="margin-left: .25rem;">
                                    Save
                                </b-button>
                            </div>
                        </b-modal>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group class="mb-4">
                        <label for="radios2" class="select-image-slider-type">Select Image Slider Type</label>
                        <b-form-radio-group id="radios2" name="radioSubComponent" v-model="form.sliderType">
                            <b-form-radio value="poster">Poster</b-form-radio>
                            <b-form-radio value="banner">Banner</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div role="group" class="sl-helper b-form-group form-group">
                        <div style="height: 15px">
                            <p class="form-list float-left">B</p>
                            <label class="col-form-label pt-0 float-left">POSTER</label>
                            <i class="guide-tooltip float-left" id="splash-tooltip"></i>
                            <b-popover target="splash-tooltip"
                                       triggers="hover"
                                       content="Sets the background that will appear when the customer application is launched.">
                            </b-popover>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="10">
                    <b-form-group id="bg-image" label-for="bg-image" class="sl-helper">
                        <b-modal id="delete-modal-bg" title="Delete Background Image">
                            <p class="modal-main-message">Are you sure you want delete this background image?</p>
                            <div slot="modal-footer">
                                <b-btn variant="ghost" class="mr-1 btn-cancel" @click="hideModal('delete-modal-bg')">
                                    Cancel
                                </b-btn>
                                <b-btn variant="primary" class="ml-1" @click="removeImage('bg')">
                                    Yes, Delete
                                </b-btn>
                            </div>
                        </b-modal>
                        <div :id="form.sliderType + '-container'" class="border mb-2">
                            <template v-if="selected_image === null">
                                <img v-if="banner_images[0].image !== ''" :src="banner_images[0].image" alt="Product Image">
                            </template>
                            <template v-else>
                                <img v-if="banner_images[selected_image].image !== ''" :src="banner_images[selected_image].image" alt="Product Image">
                            </template>
                            <div class="upload-icon rounded-circle border mb-1" @click="openCroppa()"></div>
                        </div>
                        <b-form-group
                            class="secondary-label"
                            style="font-size: 14px;"
                            :invalid-feedback="errorMessage('sliderTypeImages')"
                            :state="isValid('sliderTypeImages')">
                        </b-form-group>
                        <template v-if="form.sliderType == 'poster'">
                            <em class="image-size">Recommended size : 343 x 343px</em>
                        </template>
                        <template v-else>
                            <em class="image-size">Recommended size : 343 x 140px</em>
                        </template>
                        <span class="d-none" style="cursor: pointer" @click="removeBgImg"><img src="../../../assets/images/actions/delete.svg" /></span>
                        <div id="banner-images-container" style="width: 100%;" class="pt-2 pb-2">
                            <div v-for="(image, index) in banner_images" :key="index">
                                <div :class="{
                                    border: !image.active,
                                    'border-active': selected_image == index && image != ''
                                }">
                                    <img v-if="image.image !== ''"
                                        :src="image.image"
                                        class="product-image"
                                        alt="Product Image"
                                        @click="setActiveImage(index)">
                                    <img v-if="image.image !== '' && isRemovable()"
                                        src="@/assets/images/actions/remove.svg"
                                        alt="Remove Button"
                                        :class="{
                                            'remove-button': image.image === '',
                                            'remove-button-with-image': image.image !== ''
                                        }"
                                        @click="removeBannerImage(index)">
                                </div>
                            </div>
                        </div>
                        <BannerUpload
                            :status="modal.croppa.status"
                            :values="banner_img_upload" :sliderType="form.sliderType" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="d-none">
                <b-col>
                    <div role="group" class="sl-helper b-form-group form-group">
                        <div style="height: 15px">
                            <i class="form-list float-left">C</i>
                            <label class="col-form-label pt-0 float-left">MAIN COLOR</label>
                            <i class="guide-tooltip float-left" id="main-color-tooltip"></i>
                            <b-popover target="main-color-tooltip"
                                       triggers="hover"
                                       content="Sets the color theme of your customer application.">
                            </b-popover>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row class="d-none">
                <b-col cols="6">
                    <b-form-group id="main-color" label="Button, Border & Header" label-for="main-color" class="sl-helper">
                        <b-form-input type="color" v-model="form.button_color"  id="main-color" class="" required></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="1">
                    <img style="margin-top: 32px; margin-left: -18px" src="../../../assets/images/icons/colorpicker.svg" />
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="10">
                    <div role="group" class="sl-helper b-form-group form-group">
                        <p class="form-list float-left">C</p>
                        <label for="programname" class="col-form-label pt-0 float-left">INFORMATION</label>
                        <i class="guide-tooltip float-left" id="programname-tooltip"></i>
                        <b-popover target="programname-tooltip"
                                   triggers="hover"
                                   content="This is the official name of your loyalty program.">
                        </b-popover>
                    </div>
                    <div style="margin-top: 30px; margin-bottom: 10px;">
                        <vue-editor :editorToolbar="customToolbar" v-model="form.information"></vue-editor>
                    </div>
                    <b-form-group
                        class="secondary-label"
                        style="font-size: 14px;"
                        :invalid-feedback="errorMessage('information')"
                        :state="isValid('information')">
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="10">
                    <div role="group" class="sl-helper b-form-group form-group">
                        <p class="form-list float-left">D</p>
                        <label for="programname" class="col-form-label pt-0 float-left">MORE INFO</label>
                        <i class="guide-tooltip float-left" id="programname-tooltip"></i>
                        <b-popover target="programname-tooltip"
                                   triggers="hover"
                                   content="This is the official name of your loyalty program.">
                        </b-popover>
                    </div>
                    <div style="margin-top: 30px; margin-bottom: 10px;">
                        <vue-editor :editorToolbar="customToolbar" v-model="form.moreInformation"></vue-editor>
                    </div>
                    <b-form-group
                        class="secondary-label"
                        style="font-size: 14px;"
                        :invalid-feedback="errorMessage('moreInformation')"
                        :state="isValid('moreInformation')">
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div role="group" class="sl-helper b-form-group form-group">
                        <p class="form-list float-left mb-0">E</p>
                        <label for="programname" class="col-form-label pt-0 float-left">MAIN COLOR</label>
                        <i class="guide-tooltip float-left" id="programname-tooltip"></i>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="8">
                    <b-form-group label="Button Text">
                        <b-form-radio-group id="fontColor" v-model="form.mainColor" name="fontColor">
                            <b-form-radio value="#000000"><span class="btn-text btn-text-2" :style="'background-color: ' + form.button_color">Aa</span></b-form-radio>
                            <b-form-radio value="#FFFFFF"><span class="btn-text btn-text-1" :style="'background-color: ' + form.button_color">Aa</span></b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                    <b-form-group class="d-none" label="Dark Mode">
                        <b-form-radio-group id="darkMode" v-model="form.dark_mode" name="darkMode">
                            <b-form-radio value="0">Off</b-form-radio>
                            <b-form-radio value="1">On</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
import Switches from "vue-switches";
import { Photoshop } from "vue-color";
import { mapState, mapMutations } from "vuex";
import { VueEditor, Quill } from "vue2-editor";
import BannerImages from "./BannerImages";
import BannerUpload from "./BannerCroppa";
import $ from "jquery";

const AlignClass = Quill.import("attributors/class/align");
Quill.register(AlignClass, false);
const BackgroundClass = Quill.import("attributors/class/background");
Quill.register(BackgroundClass, false);
const ColorClass = Quill.import("attributors/class/color");
Quill.register(ColorClass, false);
const FontClass = Quill.import("attributors/class/font");
Quill.register(FontClass, false);
const SizeClass = Quill.import("attributors/class/size");
Quill.register(SizeClass, false);
const AlignStyle = Quill.import("attributors/style/align");
Quill.register(AlignStyle, false);
const BackgroundStyle = Quill.import("attributors/style/background");
Quill.register(BackgroundStyle, true);
const ColorStyle = Quill.import("attributors/style/color");
Quill.register(ColorStyle, true);
const FontStyle = Quill.import("attributors/style/font");
Quill.register(FontStyle, true);
const SizeStyle = Quill.import("attributors/style/size");
Quill.register(SizeStyle, true);

function initialBannerImages() {
    return [
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false }
    ];
}

export default {
    name: "CustomerDesignForm",
    data() {
        return {
            msg: "Design Form",
            guides: true,
            isLogoVisible: true,
            saveDesignProgress: false,
            publishDesignProgress: false,
            myLogoB64: null,
            myLogoCroppa: {},
            sliderLogoVal: 0,
            sliderLogoMin: 0,
            sliderLogoMax: 0,
            myBGB64: null,
            myBGCroppa: {},
            sliderBGVal: 0,
            sliderBGMin: 0,
            sliderBGMax: 0,
            uuid: this.$route.params.id || null,
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                [{ color: [] }],
                ["bold", "italic", "underline"],
                [{ align: "" }, { align: "center" }, { align: "right" }]
            ],
            banner_images: initialBannerImages(),
            banner_img_upload: {
                croppa: {},
                sliderVal: 0,
                sliderMin: 0,
                sliderMax: 0
            },
            selected_image: null,
            selected_image_for_rotation: null,
            form: {
                name: "Design name",
                logo_image: null,
                background_image: null,
                color: "#EBECF0",
                button_color: "#FF8828",
                font_color: "#FFFFFF",
                dark_mode: 0,
                // New Parameters
                designName: "Design name",
                isPublished: 0,
                showLogo: 1,
                imageLogo: null,
                sliderType: "poster",
                information: "",
                moreInformation: "",
                mainColor: "#000000"
            },
            intervalTest: null
        };
    },
    methods: {
        ...mapMutations("dstoreDesigns", ["setErrors"]),
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors[field];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }

            return this.errors[field] ? false : true;
        },
        rotateLogoPreview() {
            let filtered_banner_images = this.banner_images
                .filter(image => image.image != "")
                .map(image => {
                    return image.image;
                });

            // console.log(filtered_banner_images.length);
            // if (filtered_banner_images.length > 0) {
            let i = 0; // the index of the current item to show
            let vm = this;
            this.intervalTest = setInterval(function() {
                // setInterval makes it run repeatedly
                // console.log(vm.selected_image_for_rotation);
                vm.selected_image_for_rotation = i++;
                if (i == filtered_banner_images.length) i = 0; // reset to first element if you've reached the end
            }, 1000);
            // }
        },
        async saveDraftDesign() {
            this.publishDesignProgress = false;
            this.saveDesignProgress = true;

            let filtered_banner_images = this.banner_images
                .filter(image => image.image != "")
                .map(image => {
                    return image.image;
                });

            // console.log(this.form.information);
            // console.log(this.formatInformation(this.form.information));

            // console.log(filtered_banner_images);

            let param = {};
            param.design_name = this.form.designName;
            param.is_published = 0;

            param.configs = [
                {
                    key: "show_logo",
                    value: this.form.showLogo ? 1 : 0,
                    type: "string"
                },
                {
                    key: "image_logo",
                    value: this.form.logo_image,
                    type: "image"
                },
                {
                    key: "slider_type",
                    value: this.form.sliderType,
                    type: "string"
                },
                {
                    key: "information",
                    value: this.form.information,
                    type: "string"
                },
                {
                    key: "formatted_information",
                    value: JSON.stringify(
                        this.formatInformation(this.form.information)
                    ),
                    type: "string"
                },
                {
                    key: "more_information",
                    value: this.form.moreInformation,
                    type: "string"
                },
                {
                    key: "formatted_more_information",
                    value: JSON.stringify(
                        this.formatInformation(this.form.moreInformation)
                    ),
                    type: "string"
                },
                {
                    key: "main_color",
                    value: this.form.mainColor,
                    type: "string"
                },
                {
                    key: "poster",
                    value: filtered_banner_images,
                    type: "image"
                },
                {
                    key: "banner",
                    value: filtered_banner_images,
                    type: "image"
                }
            ];

            if (!this.uuid) {
                this.$store
                    .dispatch("dstoreDesigns/createDesign", param)
                    .then(() => {
                        if (this.errors == null) {
                            this.saveDesignProgress = false;
                            this.$store.dispatch("dstoreDesigns/getDesigns");
                            this.$router.push({ name: "dstoreDesign" });
                            this.uuid = null;
                            this.myLogoB64 = null;
                            this.form.logo_image = null;
                        }
                    });
            } else {
                param.uuid = this.uuid;
                this.$store
                    .dispatch("dstoreDesigns/updateDesign", param)
                    .then(() => {
                        if (this.errors == null) {
                            this.saveDesignProgress = false;
                            this.$store.dispatch("dstoreDesigns/getDesigns");
                            this.$router.push({ name: "dstoreDesign" });
                            this.uuid = null;
                            this.myLogoB64 = null;
                            this.form.logo_image = null;
                        }
                    });
            }
        },
        async publishDesign() {
            this.saveDesignProgress = false;
            this.publishDesignProgress = true;
            let filtered_banner_images = this.banner_images
                .filter(image => image.image != "")
                .map(image => {
                    return image.image;
                });

            // console.log(filtered_banner_images);

            let param = {};
            param.design_name = this.form.designName;
            param.is_published = 1;

            param.configs = [
                {
                    key: "show_logo",
                    value: this.form.showLogo ? 1 : 0,
                    type: "string"
                },
                {
                    key: "image_logo",
                    value: this.form.logo_image,
                    type: "image"
                },
                {
                    key: "slider_type",
                    value: this.form.sliderType,
                    type: "string"
                },
                {
                    key: "information",
                    value: this.form.information,
                    type: "string"
                },
                {
                    key: "formatted_information",
                    value: JSON.stringify(
                        this.formatInformation(this.form.information)
                    ),
                    type: "string"
                },
                {
                    key: "more_information",
                    value: this.form.moreInformation,
                    type: "string"
                },
                {
                    key: "formatted_more_information",
                    value: JSON.stringify(
                        this.formatInformation(this.form.moreInformation)
                    ),
                    type: "string"
                },
                {
                    key: "main_color",
                    value: this.form.mainColor,
                    type: "string"
                },
                {
                    key: "poster",
                    value: filtered_banner_images,
                    type: "image"
                },
                {
                    key: "banner",
                    value: filtered_banner_images,
                    type: "image"
                }
            ];

            if (!this.uuid) {
                this.$store
                    .dispatch("dstoreDesigns/createDesign", param)
                    .then(() => {
                        if (this.errors == null) {
                            this.publishDesignProgress = false;
                            this.$store.dispatch("dstoreDesigns/getDesigns");
                            this.$router.push({ name: "dstoreDesign" });
                            this.uuid = null;
                            this.myLogoB64 = null;
                            this.form.logo_image = null;
                        }
                    });
            } else {
                param.uuid = this.uuid;
                this.$store
                    .dispatch("dstoreDesigns/updateDesign", param)
                    .then(() => {
                        if (this.errors == null) {
                            this.publishDesignProgress = false;
                            this.$store.dispatch("dstoreDesigns/getDesigns");
                            this.$router.push({ name: "dstoreDesign" });
                            this.uuid = null;
                            this.myLogoB64 = null;
                            this.form.logo_image = null;
                        }
                    });
            }
        },
        preValidateForm(method) {
            const errorsCollection = {};
            const form = this.form;
            if (form.designName === "") {
                errorsCollection["name"] = "Design name is required";
            }

            if (!form.logo_image && this.form.showLogo) {
                errorsCollection["logo_image"] = "Logo is required";
            }

            if (form.information === "") {
                errorsCollection["information"] = "Information is required";
            } else if ($(this.form.information).text().length > 2000) {
                errorsCollection["information"] =
                    "Information must be a string with a maximum length of 2000";
            }

            let filtered_banner_images = this.banner_images
                .filter(image => image.image == "")
                .map(image => {
                    return image.image;
                });

            if (filtered_banner_images.length == 6) {
                errorsCollection["sliderTypeImages"] =
                    this.form.sliderType.replace(/\b\w/g, function(l) {
                        return l.toUpperCase();
                    }) + "s are required";
            }

            if (form.moreInformation === "") {
                errorsCollection["moreInformation"] =
                    "More information is required";
            } else if ($(this.form.moreInformation).text().length > 1000) {
                errorsCollection["moreInformation"] =
                    "More information must be a string with a maximum length of 1000";
            }

            this.setErrors(errorsCollection);

            // console.log(errorsCollection);

            if (Object.keys(errorsCollection).length <= 0) {
                if (method == "save") {
                    this.setErrors(null);
                    this.saveDraftDesign();
                } else {
                    this.setErrors(null);
                    this.publishDesign();
                }
            }
        },
        async doPublish(uuid) {
            await this.$store
                .dispatch("designs/publishCustomerDesign", {
                    uuid: uuid,
                    published: true,
                    notify: false
                })
                .then(() => {
                    if (this.uuid !== null) {
                        this.saveDraftDesign();
                    } else {
                        this.$router.push({ name: "appDesign" });
                        this.$store.dispatch("designs/getCustomerDesigns");
                    }
                });
        },
        formatInformation(information) {
            let formattedInfo = [];
            let infoChildren = $("<div>" + information + "</div>").children();

            if (infoChildren.length > 0) {
                for (let index = 0; index < infoChildren.length; index++) {
                    const element = infoChildren[index];
                    // Check if element is <br>
                    if (
                        $(element).children().length > 0 &&
                        $(element)
                            .children(0)
                            .prop("tagName")
                            .toLowerCase() == "br"
                    ) {
                        formattedInfo.push({
                            type: $(element)
                                .children(0)
                                .prop("tagName")
                                .toLowerCase(),
                            content: ""
                        });
                    } else if (
                        $(element).children().length > 0 &&
                        $(element)
                            .children(0)
                            .prop("tagName") // Check if Span's Text Is Equal to Parent Element and Check if It Has the Style Color; If It Does Add It to the Parent Style
                            .toLowerCase() == "span" &&
                        $(element).text() ==
                            $(element)
                                .children(0)
                                .text()
                    ) {
                        let parentStyle =
                            $(element).attr("style") != undefined
                                ? $(element).attr("style")
                                : "";
                        formattedInfo.push({
                            type: $(element)
                                .prop("tagName")
                                .toLowerCase(),
                            content: $(element).text(),
                            style:
                                parentStyle +
                                " " +
                                $(element)
                                    .children(0)
                                    .attr("style")
                        });
                    } else if (
                        $(element).children().length > 0 &&
                        $(element)
                            .children(0)
                            .prop("tagName") // Check if <strong></strong>
                            .toLowerCase() == "strong" &&
                        $(element).text() ==
                            $(element)
                                .children(0)
                                .text()
                    ) {
                        if (
                            $(element)
                                .children(0)
                                .children().length > 0 &&
                            $(element)
                                .children(0)
                                .children(0)
                                .prop("tagName")
                                .toLowerCase() == "em" &&
                            $(element)
                                .children(0)
                                .text() ==
                                $(element)
                                    .children(0)
                                    .children(0)
                                    .text()
                        ) {
                            // console.log(
                            //     $(element)
                            //         .children(0)
                            //         .children(0)
                            //         .children()
                            // );
                            // console.log(
                            //     $(element)
                            //         .children(0)
                            //         .children(0)
                            //         .children().length
                            // );
                            // console.log(
                            //     $(element)
                            //         .children(0)
                            //         .children(0)
                            //         .children()
                            //         .prop("tagName") // Check if <em></em>
                            //         .toLowerCase() == "u"
                            // );
                            if (
                                $(element)
                                    .children(0)
                                    .children(0)
                                    .children().length &&
                                $(element)
                                    .children(0)
                                    .children(0)
                                    .children()
                                    .prop("tagName") // Check if <u></u>
                                    .toLowerCase() == "u" &&
                                $(element)
                                    .children(0)
                                    .children(0)
                                    .text() ==
                                    $(element)
                                        .children(0)
                                        .children(0)
                                        .children()
                                        .text()
                            ) {
                                let parentStyle =
                                    $(element).attr("style") != undefined
                                        ? $(element).attr("style")
                                        : "";
                                let firstChildStyle =
                                    $(element)
                                        .children(0)
                                        .attr("style") != undefined
                                        ? $(element)
                                              .children(0)
                                              .attr("style")
                                        : "";
                                formattedInfo.push({
                                    type: $(element)
                                        .prop("tagName")
                                        .toLowerCase(),
                                    content: $(element).text(),
                                    style: (
                                        parentStyle +
                                        firstChildStyle +
                                        " " +
                                        "font-family: MainFontBold, sans-serif; font-weight: normal; font-style: italic; text-decoration: underline;"
                                    ).trim()
                                });
                            } else {
                                let parentStyle =
                                    $(element).attr("style") != undefined
                                        ? $(element).attr("style")
                                        : "";
                                let firstChildStyle =
                                    $(element)
                                        .children(0)
                                        .attr("style") != undefined
                                        ? $(element)
                                              .children(0)
                                              .attr("style")
                                        : "";
                                formattedInfo.push({
                                    type: $(element)
                                        .prop("tagName")
                                        .toLowerCase(),
                                    content: $(element).text(),
                                    style: (
                                        parentStyle +
                                        firstChildStyle +
                                        " " +
                                        "font-family: MainFontBold, sans-serif; font-weight: normal; font-style: italic;"
                                    ).trim()
                                });
                            }
                        } else {
                            let parentStyle =
                                $(element).attr("style") != undefined
                                    ? $(element).attr("style")
                                    : "";
                            let firstChildStyle =
                                $(element)
                                    .children(0)
                                    .attr("style") != undefined
                                    ? $(element)
                                          .children(0)
                                          .attr("style")
                                    : "";
                            formattedInfo.push({
                                type: $(element)
                                    .prop("tagName")
                                    .toLowerCase(),
                                content: $(element).text(),
                                style: (
                                    parentStyle +
                                    firstChildStyle +
                                    " " +
                                    "font-family: MainFontBold, sans-serif; font-weight: normal;"
                                ).trim()
                            });
                        }
                    } else {
                        formattedInfo.push({
                            type: $(element)
                                .prop("tagName")
                                .toLowerCase(),
                            content: $(element).text(),
                            style:
                                $(element).attr("style") != undefined
                                    ? $(element).attr("style")
                                    : ""
                        });
                    }
                }
            }
            return formattedInfo;
        },
        // LOGO  CROPPA
        onLogoZoom() {
            this.sliderLogoVal = this.myLogoCroppa.scaleRatio;
        },
        onNewLogoImage() {
            this.sliderLogoVal = this.myLogoCroppa.scaleRatio;
            this.sliderLogoMin = this.myLogoCroppa.scaleRatio / 2;
            this.sliderLogoMax = this.myLogoCroppa.scaleRatio * 2;
        },
        onLogoSliderChange(evt) {
            var increment = evt.target.value;
            this.myLogoCroppa.scaleRatio = +increment;
        },
        cancelUploadLogo() {
            this.$root.$emit("bv::hide::modal", "uploadLogo");
        },
        saveUploadLogo() {
            if (this.myLogoCroppa.generateDataUrl() === "") {
                return false;
            }
            this.form.logo_image = this.myLogoCroppa.generateDataUrl();
            this.cancelUploadLogo();
        },

        // BG CROPPA
        onBGZoom() {
            this.sliderBGVal = this.myBGCroppa.scaleRatio;
        },
        onNewBGImage() {
            this.sliderBGVal = this.myBGCroppa.scaleRatio;
            this.sliderBGMin = this.myBGCroppa.scaleRatio / 2;
            this.sliderBGMax = this.myBGCroppa.scaleRatio * 2;
        },
        onBGSliderChange(evt) {
            var increment = evt.target.value;
            this.myBGCroppa.scaleRatio = +increment;
        },
        cancelUploadBG() {
            this.$root.$emit("bv::hide::modal", "uploadBGImage");
        },
        saveUploadBG() {
            let _base64 = this.myBGCroppa.generateDataUrl() || null;
            if (!_base64) {
                return;
            }

            let _img64 = _base64.replace(/data:image\/png;base64,/gi, "");
            this.form.background_image = _img64;
            this.myBGB64 = _img64;
            this.cancelUploadBG();
            //Temporary Fix
            this.clearedBgImg = false;
        },
        removeBgImg() {
            //Temporary Fix
            this.form.background_image = null;
        },
        removeImage(type) {
            if (type == "bg") {
                this.form.background_image = null;
                this.form.color = "#EBECF0";
                this.hideModal("delete-modal-bg");
            } else {
                this.form.logo_image = null;
                this.hideModal("delete-modal-logo");
                this.myLogoCroppa.remove();
            }
        },
        hideModal(modal) {
            this.$root.$emit("bv::hide::modal", modal);
        },
        openCroppa: function() {
            const errorsCollection = {};
            let filtered_banner_images = this.banner_images
                .filter(image => image.image != "")
                .map(image => {
                    return image.image;
                });
            if (filtered_banner_images.length < 6) {
                this.$store.commit("dstoreDesigns/setModal", {
                    type: "croppa",
                    status: true,
                    base64: null,
                    origin: !this.uuid ? "new_design" : "edit_design"
                });
            } else {
                errorsCollection["sliderTypeImages"] =
                    "You are only allowed to upload 6 images";

                this.setErrors(errorsCollection);
            }
        },
        removeBannerImage: async function(index) {
            this.banner_images.splice(index, 1);
            this.banner_images.push({
                image: "",
                active: false
            });

            let is_images_empty = await this.banner_images
                .map(image => {
                    return image;
                })
                .filter(image => image.image == "");

            if (is_images_empty.length == 6) {
                await this.$store.commit("dstoreDesigns/setActiveImage", null);
            } else {
                await this.$store.commit("dstoreDesigns/setActiveImage", 0);
            }
        },
        setActiveImage: function(index) {
            this.$store.commit("dstoreDesigns/setActiveImage", index);
        },
        isRemovable: function() {
            let empty_images = this.banner_images
                .map(image => {
                    return image;
                })
                .filter(image => image.image == "");

            return empty_images.length < 5 ? true : false;
        }
    },
    components: {
        Switches,
        "photoshop-picker": Photoshop,
        VueEditor,
        BannerImages,
        BannerUpload
    },
    created() {
        // this.rotateLogoPreview();
        this.setErrors(null);
        if (this.uuid) {
            this.$store.dispatch("dstoreDesigns/getDesignDetails", this.uuid);
            // return;
        }
    },
    computed: {
        ...mapState("dstoreDesigns", {
            loading: state => state.loading,
            errors: state => state.errors,
            modal: state => state.modal,
            customerDesignList: state => state.customerDesignList,
            banner_active_img: state => state.banner_active_img,
            designDetails: state => state.designDetails
        })
    },
    watch: {
        designDetails: function(designDetails) {
            this.form.designName = designDetails.name;
            this.form.information = designDetails.configs.find(
                config => config.key === "information"
            ).value;
            this.form.moreInformation = designDetails.configs.find(
                config => config.key === "more_information"
            ).value;
            this.form.mainColor = designDetails.configs.find(
                config => config.key === "main_color"
            ).value;
            this.form.logo_image = designDetails.configs.find(
                config => config.key === "image_logo"
            ).value;
            this.form.sliderType = designDetails.configs.find(
                config => config.key === "slider_type"
            ).value;

            const showLogoConfig = designDetails.configs.find(config => config.key === 'show_logo');

            if (showLogoConfig) {
                this.form.showLogo = parseInt(showLogoConfig.value)
            }

            if (
                designDetails.configs.find(
                    config => config.key === "slider_type"
                ).value === "poster"
            ) {
                let posterImages = designDetails.configs
                    .find(config => config.key === "poster")
                    .value.split(",");
                for (let index = 0; index < posterImages.length; index++) {
                    this.banner_images[index].image = posterImages[index];
                }
            } else {
                let bannerImages = designDetails.configs
                    .find(config => config.key === "banner")
                    .value.split(",");
                for (let index = 0; index < bannerImages.length; index++) {
                    this.banner_images[index].image = bannerImages[index];
                }
            }
            this.rotateLogoPreview();
        },
        banner_active_img: function(index) {
            this.selected_image = index;
        },
        "modal.croppa.status": function(status) {
            if (status === true) {
                this.banner_img_upload.croppa.remove();
            }
        },
        "modal.croppa.base64": function(base64) {
            if (base64 !== null) {
                clearInterval(this.intervalTest);
                let empty_images = this.banner_images
                    .map((image, index) => {
                        return {
                            image: image.image,
                            index: index
                        };
                    })
                    .filter(image => image.image == "");

                let get_index = empty_images[0].index;

                if (this.banner_images[0] !== "") {
                    this.$store.commit("dstoreDesigns/setActiveImage", 0);
                }

                this.banner_images[get_index].image = base64;
                this.rotateLogoPreview();
            }
        },
        "form.sliderType": function() {
            if (!this.uuid) {
                this.banner_images = initialBannerImages();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.poster-additiional-images {
    div {
        margin-top: 6px;
        border: 0.8px solid #ff8828;
        border-radius: 3.2px;
        width: 40px;
        height: 40px;
        display: inline-block;
        margin-right: 8px;
    }
    .image {
        background: #ffffff
            url("../../../assets/images/achievement/default-image.svg")
            no-repeat center;
        background-size: 25px;
    }
    .add-image {
        background: #ffffff url("../../../assets/images/actions/add-orange.svg")
            no-repeat center;
        background-size: 15px;
    }
}

.col-form-label {
    font-family: MainFontBold, sans-serif;
}

.select-image-slider-type {
    font-family: MainFontRegular, sans-serif !important;
    font-size: 13px !important;
    color: #2a2a2a;
}

.design-page-canvas-header {
    background-color: #fff;
    border-bottom: 1px solid #ddd;
    border-top: 1px solid #ddd;
}

.design-home {
    padding: 3px 10px;
    border-right: 1px solid #ddd;
    font-size: 2em;
    color: #000;
}

.design-title {
    padding: 1em;
    input {
        border: none;
    }
}

.design-title img {
    margin-right: 10px;
}

// Colors
$bg-color: #f3f3f4;
$dot-color: #ccc;

// Dimensions
$dot-size: 2px;
$dot-space: 41px;

.canvas-background {
    height: 700px;
    background: linear-gradient(
                90deg,
                $bg-color ($dot-space - $dot-size),
                transparent 1%
            )
            center,
        linear-gradient($bg-color ($dot-space - $dot-size), transparent 1%)
            center,
        $dot-color;
    background-size: $dot-space $dot-space;
}

.design-page-form {
    padding-top: 20px;
    background-color: #fff;
    border-left: 1px solid #ddd;
    border-top: 1px solid #ddd;
    height: 100%;
}

.new-badge {
    font-size: 13px;
    border-radius: 22px;
    padding: 8px 16px;
    margin-left: 10px;
}

.new-badge.invert-new-badge {
    background-color: #fff;
    color: #ff8828;
}
.image-upload-preview {
    width: 98px;
    height: 46px;
    background: #f7f8fb;
    border: 1px solid #e3e3e3;
    border-radius: 8px;
    background: #ffffff
        url("../../../assets/images/achievement/default-image.svg") no-repeat
        center;
    img.image {
        width: 128px;
        height: 66px;
        border-radius: 5px;
    }

    span.img-icon {
        box-shadow: 0 0 3px #ccc, inset 0 0 3px #b8b8b8;
        padding: 2px;
        border-radius: 12.5px;
        position: absolute;
        width: 25px;
        height: 25px;
        text-align: center;
        bottom: 40px;
        left: 170px;
    }
}

.image-upload {
    margin-bottom: 8px;
    width: 289px;
    height: 135px;
    background: #f7f8fb;
    border: 1px solid #e3e3e3;
    border-radius: 8px;
    background: #ffffff
        url("../../../assets/images/achievement/default-image.svg") no-repeat
        center;
    img.image {
        width: 289px;
        height: 135px;
        border-radius: 5px;
    }

    span.img-icon {
        box-shadow: 0 0 3px #ccc, inset 0 0 3px #b8b8b8;
        padding: 2px;
        border-radius: 12.5px;
        position: absolute;
        width: 25px;
        height: 25px;
        text-align: center;
        bottom: 38px;
        left: 273px;
    }
}
.poster-preview {
    margin-top: 12px;
    margin-bottom: 12px;
    width: 225px;
    height: 225px;
    background: #f7f8fb;
    border: 1px solid #e3e3e3;
    border-radius: 8px;
    background: #ffffff
        url("../../../assets/images/achievement/default-image.svg") no-repeat
        center;
    img.image {
        width: 128px;
        height: 66px;
        border-radius: 5px;
    }

    span.img-icon {
        box-shadow: 0 0 3px #ccc, inset 0 0 3px #b8b8b8;
        padding: 2px;
        border-radius: 12.5px;
        position: absolute;
        width: 25px;
        height: 25px;
        text-align: center;
        bottom: 40px;
        left: 170px;
    }
}
#information {
    text-align: center;
    color: #555555;
    font-size: 9.84px;
    margin-bottom: 8px;
    font-family: MainFontRegular, sans-serif;
}
#more-info {
    text-align: center;
    text-decoration-line: underline;
    color: #f69a44;
    font-size: 9.84px;
    font-family: MainFontRegular, sans-serif;
}
span.previewremovelogo {
    top: 13px;
    left: 342px;
    position: absolute;
    z-index: 9;
    cursor: pointer;
}

span.previewremovebg {
    top: 10px;
    left: 123px;
    position: absolute;
}

#mobile-canvas {
    background-image: url("../../../assets/images/phone.svg");
    background-repeat: no-repeat;
    background-position: center;
    min-height: 680px;
    width: 304px;
    padding-top: 62px;

    .background-display {
        padding-top: 80px;
        width: 248px;
        border-radius: 20px;
        padding-bottom: 163px;
    }

    h5 {
        font-family: MainFontBold, sans-serif;
    }

    .reward-description {
        font-family: MainFontRegular, sans-serif;
        font-size: 12px;
        color: #2a2a2a;
    }
    .reward-points {
        font-family: MainFontBold, sans-serif;
        font-size: 12px;
        color: #2a2a2a;
    }

    .image-upload {
        border: 1px dashed #e3e3e3;
    }

    button.canvas-button {
        width: 230px;
        font-size: 13px;
        border-radius: 22px;
        padding: 8px 16px;
        border: 1px solid #fff;
        font-family: MainFontBold, sans-serif;
        font-weight: normal;
    }
}

.image-upload-bg {
    height: 289px;
    width: 289px;
    span.img-icon {
        left: 273px;
        bottom: 98px;
    }
}

.form-list {
    width: 15px;
    height: 15px;
    padding: 1px;
    border-radius: 50%;
    background-color: #7a7a7a;
    color: #f7f8fb;
    font-size: 9px;
    text-align: center;
    cursor: pointer;
    margin-right: 5px;
}

.image-size {
    font-size: 12px;
    font-family: MainFontRegular, sans-serif;
    color: #68737d;
}

.btn-text {
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
    padding: 5px;
    border: 1px solid #b8b8b8;
    background-color: #15b0db;
    border-radius: 6px;
}

.btn-text-1 {
    color: #fff;
}

.btn-text-2 {
    color: #000;
}
</style>
